import useCurrentUser from './useCurrentUser';

export const useHasPermissions = (permissionNames, location) => {
  const permissions = useCurrentUser().currentUser?.permissions;

  if (!permissions || location?.pathname?.includes('login')) return false;

  if (typeof permissionNames === 'number') return permissions.includes(permissionNames);
  if (Array.isArray(permissionNames)) return permissionNames.some((permissionName) => permissions.includes(permissionName));
  return false;
};
